var _excluded = ["input", "className", "onUploadFailure", "onUploadSuccess", "upload", "uploadStatus"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import FileInput from './file-input';
import { fieldPropTypes } from '../helpers';
import { compose, cloudinaryUploader, noop } from '../../utils';
import classnames from 'classnames';
/**
 *
 * A wrapper around the {@link FileInput} component that automatically uploads files to cloudinary via the [cloudinaryUploader](https://github.com/LaunchPadLab/lp-hoc/blob/master/docs.md#cloudinaryuploader) HOC.
 * The value of this input is the public URL of the uploaded file.
 * Additionally, the `uploadStatus` passed down from `cloudinaryUploader` will be added as a class on the input.
 * 
 * You can pass arguments to the instance of `cloudinaryUploader` via this component's props,
 * or via the `CLOUDINARY_CLOUD_NAME` and `CLOUDINARY_BUCKET` env vars (recommended).
 * 
 *
 * @name CloudinaryFileInput
 * @type Function
 * @param {Object} input - A `redux-forms` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object
 * @param {Object} meta - A `redux-forms` [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) object
 * @param {Function} [onUploadSuccess] - A handler that gets invoked with the response from a successful upload to Cloudinary
 * @param {Function} [onUploadFailure] - A handler that gets invoked with the error from a failed upload to Cloudinary
 * @example
 * 
 * function HeadshotForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field 
 *          name="headshotUrl" 
 *          component={ CloudinaryFileInput }
 *          cloudName="my-cloudinary-cloud"
 *          bucket="my-cloudinary-bucket"
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 */

var propTypes = _objectSpread(_objectSpread({}, fieldPropTypes), {}, {
  onUploadFailure: PropTypes.func,
  onUploadSuccess: PropTypes.func,
  upload: PropTypes.func.isRequired,
  uploadStatus: PropTypes.string.isRequired
});

var defaultProps = {
  onUploadSuccess: noop,
  onUploadFailure: noop
};

function CloudinaryFileInput(_ref) {
  var input = _ref.input,
      className = _ref.className,
      onUploadFailure = _ref.onUploadFailure,
      onUploadSuccess = _ref.onUploadSuccess,
      upload = _ref.upload,
      uploadStatus = _ref.uploadStatus,
      rest = _objectWithoutProperties(_ref, _excluded);

  var onChange = input.onChange;
  return (
    /*#__PURE__*/
    React.createElement(FileInput, _extends({
      input: _objectSpread(_objectSpread({}, input), {}, {
        onChange: noop
      }),
      onLoad: function onLoad(fileData, file) {
        return upload(fileData, file).then(function (res) {
          onChange(res.url);
          return onUploadSuccess(res);
        }, function (err) {
          return onUploadFailure(err);
        });
      },
      className: classnames(uploadStatus, className)
    }, rest))
  );
}

CloudinaryFileInput.propTypes = propTypes;
CloudinaryFileInput.defaultProps = defaultProps;
export default compose(cloudinaryUploader())(CloudinaryFileInput);